export const buildVersion = '1.2.26030426';
export const buildTimestamp = 1772652120749;
